export default "__VITE_ASSET__CW1xD8Cq__"